import React from 'react';
import { connect } from 'react-redux';
import dividendAnalysisService from '../../../core/services/Fundamental/DividendAnalysisService';
import { getCurrentDate } from '../../helpers/Common';
import { handleExport } from '../../helpers/HandleExport';
import { I18n } from 'react-redux-i18n';
import { withComponentId } from './../../common/ComponentIdContext';
import { compose } from 'redux';
import { REDUCER_NAME } from './reducer';
import { Export } from './../../common/export';

class ExportData extends React.Component {
  onClickExport = async () => {
    const { displayCode, code } = this.props;
    const fileName = I18n.t('common.export.cashDividendAnalysis', {
      date: getCurrentDate(),
      ticker: displayCode,
    });
    const params = {
      OrganCode: code,
    };
    const data = await dividendAnalysisService.ExportData(params);
    handleExport(data, fileName);
  };

  render() {
    return (
      <div className="pd-top-navigation--right pd-top-navigation--right-indica pb-10">
        <Export exportAction={this.onClickExport} />
      </div>
    );
  }
}

const mapStateToProps = (state, { componentId }) => {
  const { dataDividendTableByYear } = state[REDUCER_NAME].listMultiComponent[
    componentId
  ];

  return {
    i18n: state.i18n,
    dataDividendTableByYear,
  };
};

export default compose(
  withComponentId,
  connect(mapStateToProps),
)(ExportData);
